export default __webpack_public_path__ + "static/media/GameArchLogo.2fada958.svg";